































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';

import AddOrUpdateContactDialog from '@/modules/CRM/components/AddOrUpdateContactDialog.vue';
import AddOrUpdateCompanyDialog from '@/modules/CRM/components/AddOrUpdateCompanyDialog.vue';

@Component({
  components: {
    Popup,
    AddOrUpdateContactDialog,
    AddOrUpdateCompanyDialog,
  },
})
export default class AddContactDialog extends Vue {
    @Prop({required: false, default: ''})
    private relationId?: string;

    @Prop({required: false, default: ''})
    private projectId?: string;

    private show: boolean = false;
    private isSubcontractor: boolean = false;

    public open() {
        this.show = true;
    }

    private addContact() {
        (this.$refs.AddOrUpdateContactDialog as AddOrUpdateContactDialog).open();
        this.show = false;
    }

    private addCompany() {
      this.isSubcontractor = false;
      (this.$refs.AddOrUpdateCompanyDialog as AddOrUpdateCompanyDialog).open();
      this.show = false;
    }

    private addSubcontractor() {
      this.isSubcontractor = true;
      (this.$refs.AddOrUpdateCompanyDialog as AddOrUpdateCompanyDialog).open();
      this.show = false;
    }

    private updateEvent(e: string) {
        this.$emit('created', e);
    }
}
